import React from 'react'
import Title from '../../../../../../components/typography/title.component.jsx'
import Container from '../../../../../../components/layout/container.component.jsx'
import SearchForm from '../../components/search-form.component'
import FontAwesome from 'react-fontawesome'
import ModalConfirmation from '../../../../../../components/modal/modal-confirmation.component.jsx'
import AccordionSecondary from '../../../../../../components/accordion/accordion-secondary.component.jsx'
import PaginationComponent from '../../../../../../components/pagination/pagination.component.jsx'
import { PRIMARY_COLOR } from '../../../../../../styles/colors.style'
import { routes } from '../../../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../../actions/toast.actions'
import { CouponService } from '../../../../../../services/coupon.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../../ducks/site/site'

class CouponSearchPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			active: '',
			name: '',
			couponType: '',
			modalTitle: '',
			modalMessage: '',
			modalIsOpen: false,
		}
		this.couponId = null
		this.isCouponActive = null
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loading && !this.props.loading) {
			this.refs.pagination.reload()
		}
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	render() {
		const {
			name,
			active,
			couponType,
			modalTitle,
			modalIsOpen,
			modalMessage,
		} = this.state

		return (
			<Container>
				<Title>Cupons</Title>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={getAccordionItems.call(this)}
				/>
				<div data-permission="F5825B6EAE1FD289E2AB1F87AF27CC40598B95BC">
					<PaginationComponent
						ref={'pagination'}
						getData={CouponService.search}
						headers={paginationHeaders}
						params={{
							name,
							active,
							couponType,
						}}
						rowsPerPage={50}
						sortable={paginationSortable}
						renderRow={paginationRenderRow.bind(this)}
					/>
				</div>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={modalTitle}
					onResult={onResult.bind(this)}>
					{modalMessage}?
				</ModalConfirmation>
			</Container>
		)
	}
}

const paginationHeaders = [
	{ header: 'Código', key: 'couponCode', align: 'center' },
	{ header: 'Descrição', key: 'couponDescription', align: 'center' },
	{ header: 'Data início', key: 'dateStart', align: 'center' },
	{ header: 'Data fim', key: 'dateEnd', align: 'center' },
	{ header: 'Qtd cupons', key: 'couponsAmount', align: 'center' },
	{ header: 'Cupons por cliente', key: 'couponsPerClient', align: 'center' },
	{ header: 'Cupons resgatados', key: 'redeemedCoupons', align: 'center' },
	{ header: 'Tipo', key: 'couponType', align: 'center' },
	{ header: 'Situação', key: 'status', align: 'center' },
	{ header: 'Parceiro', key: 'busCompany', align: 'center' },
	{ header: 'Cliente', key: 'moveflexNumber', align: 'center' },
]

const paginationSortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'dateStart' },
		{ key: 'dateEnd' },
		{ key: 'couponCode' },
		{ key: 'couponsAmount' },
		{ key: 'couponsPerClient' },
		{ key: 'redeemedCoupons' },
		{ key: 'couponType' },
		{ key: 'status' },
		{ key: 'busCompany' },
		{ key: 'moveflexNumber' },
	],
}

function getAccordionItems() {
	return [
		{
			title: 'Filtros',
			content: (
				<SearchForm
					ref={'form'}
					onSubmit={handleSubmit.bind(this)}
					history={this.props.history}
				/>
			),
		},
	]
}

function paginationRenderRow(rowData, headers) {
	return headers.map(({ key }) => {
		const cellData = rowData[key]
		const couponId = rowData['id']
		if (key == 'status') {
			const isActive = rowData['status']
			return (
				<td key={key} align="center">
					<FontAwesome
						style={isActive ? { color: PRIMARY_COLOR } : {}}
						name={isActive ? 'toggle-on' : 'toggle-off'}
						size="lg"
						title={isActive ? 'Cupom ativo' : 'Cupom inativo'}
						onClick={(e) => {
							e.stopPropagation()
							this.couponId = couponId
							this.isCouponActive = isActive
							this.setState({
								modalTitle: `${isActive ? 'Inativar' : 'Ativar'} cupom`,
								modalMessage: `Confirma a ${
									isActive ? 'inativação' : 'ativação'
								} do cupom ${rowData['couponCode']}`,
								modalIsOpen: true,
							})
						}}
					/>
				</td>
			)
		} else {
			return (
				<td
					key={key}
					style={{ textAlign: 'center' }}
					onClick={viewCoupon.bind(this, couponId)}>
					<span title={cellData}>{cellData}</span>
				</td>
			)
		}
	})
}

function onResult(confirmed) {
	this.setState({ modalIsOpen: false })
	if (!confirmed) return
	const { showLoading, hideLoading, success, danger } = this.props
	showLoading()
	if (this.isCouponActive) {
		CouponService.inactivate(this.couponId)
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Cupom inativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível inativar o cupom, por favor tente novamente mais tarde',
				})
			})
	} else {
		CouponService.activate(this.couponId)
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Cupom ativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível ativar o cupom, por favor tente novamente mais tarde',
				})
			})
	}
}

function viewCoupon(couponId) {
	this.props.history.push(`${routes.ADMIN}/cupom-de-desconto/${couponId}`)
}

function handleSubmit({ active, name, couponType }) {
	this.setState(
		{
			name,
			active,
			couponType,
		},
		() => this.refs.pagination.reload()
	)
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
		},
		dispatch
	)

const connectedCouponSearchPageComponent = withRouter(
	connect(null, mapDispatchToProps)(CouponSearchPageComponent)
)

export { connectedCouponSearchPageComponent as ModuleRootComponent }
